import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";

// EXE events schedule with specific dates and times
const exeEvents = [
  {
    title: "Registration Ends",
    date: new Date("2025-07-28T00:00:00"),
    shortTitle: "Registration Ends"
  },
  {
    title: "2D Game Session",
    date: new Date("2025-07-21T19:00:00"), // 7PM IST
    shortTitle: "2D Game Session"
  },
  {
    title: "2D Game Session",
    date: new Date("2025-07-23T19:00:00"), // 7PM IST
    shortTitle: "2D Game Session"
  },
  {
    title: "EXE Introduction",
    date: new Date("2025-08-01T19:00:00"), // 7PM IST
    shortTitle: "EXE Introduction"
  },
  {
    title: "GDD Phase Start",
    date: new Date("2025-08-02T00:00:00"),
    shortTitle: "GDD Phase Start"
  },
  {
    title: "How to make a GDD Session",
    date: new Date("2025-08-02T16:00:00"), // 4PM IST
    shortTitle: "How to make a GDD Session"
  },
  {
    title: "GDD Phase Ends", 
    date: new Date("2025-08-08T23:59:59"),
    shortTitle: "GDD Phase Ends"
  },
  {
    title: "Game Dev Phase",
    date: new Date("2025-08-10T00:00:00"),
    shortTitle: "Game Dev Phase"
  },
  {
    title: "Development Sessions",
    date: new Date("2025-08-10T19:00:00"), // 7PM IST
    shortTitle: "Dev Sessions"
  },
  {
    title: "Timless Toucan Session",
    date: new Date("2025-08-15T20:00:00"), // 8PM IST
    shortTitle: "Azoove Session"
  },
  {
    title: "GDGSL Session",
    date: new Date("2025-08-19T19:00:00"), // 7PM IST
    shortTitle: "GDGSL Session"
  },
  {
    title: "Dev Phase Ends",
    date: new Date("2025-08-23T23:59:59"),
    shortTitle: "Dev Phase Ends"
  },
  {
    title: "Game Submissions Ends",
    date: new Date("2025-08-24T23:59:59"),
    shortTitle: "Game Submissions Ends"
  },
  {
    title: "EXE Final",
    date: new Date("2025-08-30T12:00:00"), 
    shortTitle: "EXE Final"
  }
];

const EXECountdown = () => {
  const [nextEvent, setNextEvent] = useState(null);

  useEffect(() => {
    const getNextEvent = () => {
      const now = new Date();
      const upcomingEvents = exeEvents.filter(event => event.date > now);
      
      if (upcomingEvents.length === 0) {
        return null;
      }
      
      // Sort by date and return the closest upcoming event
      upcomingEvents.sort((a, b) => a.date - b.date);
      return upcomingEvents[0];
    };

    const updateNextEvent = () => {
      setNextEvent(getNextEvent());
    };

    // Update immediately
    updateNextEvent();
    
    // Update every minute to keep it current
    const interval = setInterval(updateNextEvent, 60000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="countdown" className="exe-section">
      <div className="exe-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          viewport={{ once: true }}
          className="text-center"
        >
          {/* Background glow effect */}
          <motion.div
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-exe-primary opacity-5 rounded-full blur-3xl"
            animate={{
              scale: [1, 1.1, 1],
              opacity: [0.02, 0.05, 0.02],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              repeatType: "loop",
            }}
          />

          <div className="flex flex-col justify-center items-center py-12 relative z-10">
            <motion.h2
              className="exe-title text-exe-text-accent mb-6"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ 
                duration: 0.3,
                ease: "easeOut",
                delay: 0.06
              }}
              viewport={{ once: true }}
            >
              Next Event
            </motion.h2>
            
            <motion.h3
              className="text-heading exe-text-gradient mb-8 text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ 
                duration: 0.3,
                ease: "easeOut",
                delay: 0.12
              }}
              viewport={{ once: true }}
            >
              {nextEvent ? nextEvent.shortTitle : "No Upcoming Events"}
            </motion.h3>
            
            <motion.div
              className="scale-[0.8] sm:scale-100"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ 
                duration: 0.3,
                ease: "easeOut",
                delay: 0.18
              }}
              viewport={{ once: true }}
            >
              {nextEvent ? (
                <FlipClockCountdown
                  to={nextEvent.date}
                  labels={["DAYS", "HOURS", "MINUTES", "SECONDS"]}
                  labelStyle={{
                    fontSize: 12,
                    color: "#fff",
                    marginTop: 4,
                    fontFamily: "'JetBrains Mono', monospace",
                  }}
                  digitBlockStyle={{
                    backgroundColor: "#000000",
                    color: "#53f032",
                    fontSize: 24,
                    fontFamily: "'JetBrains Mono', monospace",
                    border: "2px solid #53f032",
                    borderRadius: 8,
                    textShadow: "0 0 8px #53f032",
                  }}
                  dividerStyle={{ color: "#fff" }}
                />
              ) : (
                <div className="text-exe-text-secondary text-center p-8">
                  <p className="text-body">Stay tuned for upcoming events!</p>
                </div>
              )}
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default EXECountdown;
